export default "__VITE_ASSET__1z2BompX__"